import { render, staticRenderFns } from "./privacyPolicy.vue?vue&type=template&id=4d8ae16d&scoped=true&"
import script from "./privacyPolicy.vue?vue&type=script&lang=js&"
export * from "./privacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./privacyPolicy.vue?vue&type=style&index=0&id=4d8ae16d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8ae16d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d8ae16d')) {
      api.createRecord('4d8ae16d', component.options)
    } else {
      api.reload('4d8ae16d', component.options)
    }
    module.hot.accept("./privacyPolicy.vue?vue&type=template&id=4d8ae16d&scoped=true&", function () {
      api.rerender('4d8ae16d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/privacyPolicy.vue"
export default component.exports